const setCollageImagesGrid = (screenType) => {
  const getRandom = (min, max) => Math.round(Math.random() * (max - min) + min);
  const collageImages = document.querySelectorAll('.collage__image');
  const placeholders = document.querySelectorAll('.collage__image-placeholder');
  if (screenType === 'desktop') {
    let numberOfLandscapes = 0;
    collageImages.forEach((picture, index) => {
      const image = picture.querySelector('img'); // Actual img is nested inside <div> when using component-lazy-image
      // Handle landscape images
      const isLandscape = image.dataset.name.includes('landscape') || image.getBoundingClientRect().width > image.getBoundingClientRect().height;
      if ((index + numberOfLandscapes) % 2 === 0 && isLandscape) {
        picture.classList.add('landscape');
        numberOfLandscapes += 1;
      }

      // Set padding
      let maxVerticalSpace = 200;
      const top = 
        index <= 1 ? 0 // First 2 pictures should have 0 padding-top (keep consistent distance to text above)
        : getRandom(0, maxVerticalSpace);
      maxVerticalSpace -= top;
      const bottom =
        index + 2 >= collageImages.length ? 0 // Bottom 2 pictures should have 0 padding-bottom (keep consistent distance to text below)
        : index <=1 ? getRandom(0, maxVerticalSpace / 2) // First 2 should have less padding bottom
        : getRandom(0, maxVerticalSpace);

      let maxHorizontalSpace = 200;
      const left = getRandom(0, maxHorizontalSpace);
      maxHorizontalSpace -= left;
      const right = getRandom(0, maxHorizontalSpace);
      picture.style.padding = `${top}px ${right}px ${bottom}px ${left}px`;

      // Set object-position
      const textAlignArray = ['left', 'center', 'right'];
      
      isLandscape ? picture.style.textAlign = 'center'
      : ((index - numberOfLandscapes) % 2 === 0) ? picture.style.textAlign = textAlignArray[getRandom(1, 2)]
      : picture.style.textAlign = textAlignArray[getRandom(0, 1)];
      image.setAttribute('height', '100%');

      // Check if it's the last loop, if so, reveal images by hiding placeholder
      if (index + 1 === collageImages.length) {
        placeholders.forEach(placeholder => placeholder.classList.add('hide'))
        collageImages.forEach(picture => picture.querySelector('img').classList.add('show'))
      }
    })
  } else {
    collageImages.forEach((picture, index) => {
      picture.style.marginTop = '0px'; // Reset marginTop in case user went from desktop size to mobile size
      const left = 
        index % 2 === 0 ? Math.floor(Math.random() * 20) // Left pictures should have smaller padding-left to be closer to the left side
        : Math.floor(Math.random() * 100);
      const right =
        index % 2 === 1 ? Math.floor(Math.random() * 20) // Right pictures should have smaller padding-right to be closer to the right side
        : Math.floor(Math.random() * 100);
      picture.style.padding = `${0}px ${right}px ${0}px ${left}px`;
    })
  }
}

let originalScreenType = window.screen.width >= 1023 ? 'desktop' : 'mobile';

window.addEventListener('load', () => {
  setCollageImagesGrid(originalScreenType);
})

window.addEventListener('resize', e => {
  let newScreenType = window.screen.width >= 1023 ? 'desktop' : 'mobile';
  if (originalScreenType != newScreenType) {
    setCollageImagesGrid(newScreenType);
  }
  originalScreenType = newScreenType;
})